import React from 'react';

import Button from 'core/modules/atoms/Button';
import FormField from 'ui/molecules/form-field/FormField';
import InputText from 'ui/atoms/InputText/InputText';

const ResetForm = () => {
  // deprecated

  return (
    <div className="login-form">
      <div className="login-form__item">
        <h3 className="login-form__title">Reset Password</h3>
      </div>
      <div className="login-form__item">
        <FormField label="Password">
          <InputText type="password" />
        </FormField>
      </div>
      <div className="login-form__item">
        <FormField label="Repeat Password">
          <InputText type="password" />
        </FormField>
      </div>
      <div className="login-form__item">
        <Button text="Reset Password" />
      </div>
    </div>
  );
};

export default ResetForm;
